import React from 'react';
import {
    Form,
    ControlLabel,
    FormGroup,
    FormControl,
    Row,
    Radio,
    Col
} from 'react-bootstrap'
import { VARCHAR_255, VARCHAR_50, VARCHAR_100 } from '../../utils/numberConstants';

class ClubRegistrationFirstStep extends React.Component {
    constructor() {
        super();
        this.state = {
            serialNumberValue: ''
        }
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.club = { id: 0 };
        this.adminStreetName = '';
        this.adminHouseNumber = '';
        this.adminPostalCode = '';
        this.adminCityName = '';
        this.adminCountry = { id: 0 };
        this.adminIsMainStadium = false;
        this.mainStadiumStreetName = '';
        this.mainStadiumHouseNumber = '';
        this.mainStadiumPostalCode = '';
        this.mainStadiumCityName = '';
        this.mainStadiumCountry = { id: 0 };
        this.secondStadium = false;
        this.secondStadiumStreetName = '';
        this.secondStadiumHouseNumber = '';
        this.secondStadiumPostalCode = '';
        this.secondStadiumCityName = '';
        this.secondStadiumCountry = { id: 0 };
        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.setDefaultValues = this.setDefaultValues.bind(this);
        this.handleClubChange = this.handleClubChange.bind(this);
        this.setDataOnModel = this.setDataOnModel.bind(this)
    }
    componentDidMount() {
        this.props.onRef(this);
        this.setDefaultValues();
    }
    handleChange(e) {
        if (e.target.type === 'text') {
            this[e.target.name] = e.target.value;
        } else if (e.target.type === 'select-one') {
            this[e.target.name] = { id: Number(e.target.value), description: e.target.selectedOptions[0].label }
        }
    }

    handleClubChange(e) {

        let selectedClub = this.props.clubs.find(club => Number(e.target.value) === club.id);
        this.club = {
            id: Number(e.target.value),
            serialNumber: selectedClub.serialNumber,
            registeredName: selectedClub.registeredName
        }
        this.setState({
            serialNumberValue: selectedClub ? selectedClub.serialNumber : ''
        }, () => {
            this.props.getTeamsByClub(this.club.id)
        })
    }
    setDefaultValues() {
        this.club = {
            id: this.props.clubRegistrationModel['club.id'],
            serialNumber: this.props.clubRegistrationModel['club.serialNumber'],
            registeredName: this.props.clubRegistrationModel['club.registeredName']
        };
        if (this.club.serialNumber) {
            this.setState({
                serialNumberValue: this.club.serialNumber
            })
        }
        this.adminStreetName = this.props.clubRegistrationModel.adminStreetName;
        this.adminHouseNumber = this.props.clubRegistrationModel.adminHouseNumber;
        this.adminPostalCode = this.props.clubRegistrationModel.adminPostalCode;
        this.adminCityName = this.props.clubRegistrationModel.adminCityName;
        this.adminCountry = {
            id: this.props.clubRegistrationModel['adminCountry.id'],
            description: this.props.clubRegistrationModel['adminCountry.description']
        };
        this.adminIsMainStadium = this.props.clubRegistrationModel.adminIsMainStadium;
        this.props.setRadiofieldChecked('firstStageForm', 'adminIsMainStadium', this.adminIsMainStadium)

        if (this.adminIsMainStadium) {
            this.handleRadioChange(this.adminIsMainStadium, 'adminIsMainStadium')
        }
        this.mainStadiumStreetName = this.props.clubRegistrationModel.mainStadiumStreetName;
        this.mainStadiumHouseNumber = this.props.clubRegistrationModel.mainStadiumHouseNumber;
        this.mainStadiumPostalCode = this.props.clubRegistrationModel.mainStadiumPostalCode;
        this.mainStadiumCityName = this.props.clubRegistrationModel.mainStadiumCityName;
        this.mainStadiumCountry = {
            id: this.props.clubRegistrationModel['mainStadiumCountry.id'],
            description: this.props.clubRegistrationModel['mainStadiumCountry.description']
        };
        this.secondStadium = this.props.clubRegistrationModel.secondStadium;
        this.props.setRadiofieldChecked('firstStageForm', 'secondStadium', this.secondStadium)

        if (this.secondStadium) {
            this.handleRadioChange(this.secondStadium, 'secondStadium')
        }
        this.secondStadiumStreetName = this.props.clubRegistrationModel.secondStadiumStreetName;
        this.secondStadiumHouseNumber = this.props.clubRegistrationModel.secondStadiumHouseNumber;
        this.secondStadiumPostalCode = this.props.clubRegistrationModel.secondStadiumPostalCode;
        this.secondStadiumCityName = this.props.clubRegistrationModel.secondStadiumCityName;
        this.secondStadiumCountry = {
            id: this.props.clubRegistrationModel['secondStadiumCountry.id'],
            description: this.props.clubRegistrationModel['secondStadiumCountry.description']
        };
        this.forceUpdate()
    }


    onSubmit(model) {
        this.setDataOnModel(model);
        let isValid = model.firstStageValidity();
        return isValid;
    }

    setDataOnModel(model) {
        model.setAdminData(this.club.id, this.club.serialNumber, this.club.registeredName, this.adminStreetName, this.adminHouseNumber, this.adminPostalCode, this.adminIsMainStadium, this.adminCityName, this.adminCountry.id, this.adminCountry.description)
        this.adminIsMainStadium && model.setMainStadiumData(this.mainStadiumStreetName, this.mainStadiumHouseNumber, this.mainStadiumPostalCode, this.mainStadiumCityName, this.mainStadiumCountry.id, this.mainStadiumCountry.description, this.secondStadium)
        this.secondStadium && model.setSecondStadiumData(this.secondStadiumStreetName, this.secondStadiumHouseNumber, this.secondStadiumPostalCode, this.secondStadiumCityName, this.secondStadiumCountry.id, this.secondStadiumCountry.description)

    }

    handleRadioChange(e, checkedValue) {
        if (typeof e === 'boolean') {
            this[checkedValue] = e;
        } else {
            this[checkedValue] = e.target.value == 'true';
        }
        try {
            let element = null;
            element = document.getElementsByClassName(checkedValue + 'Fieldset')[0]
            element.classList.toggle(checkedValue + 'FieldsetHidden', !this[checkedValue])
        } catch (error) {
            console.log(error)
        }
        if (this[checkedValue] === false && checkedValue === 'adminIsMainStadium') {
            this.handleRadioChange(false, 'secondStadium')
        }
    }
    render() {
        let { composingLabel } = this.props;
        return (
            <Form name='firstStageForm'>
                <fieldset className='registrationFieldSet'>
                    <legend className="registerFieldsetLabel">{composingLabel('sportOauthLabel.clubGeneralInfo', 'Club general info')}</legend>
                    <Row className="show-grid">
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="registeredNameSelect">
                                <Col className='registerFieldLabel' componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12}>{composingLabel('sportOauthLabel.registeredName', 'Registered name', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl
                                        className='registerField'
                                        componentClass="select"
                                        name='club'
                                        defaultValue={this.club}
                                        onChange={this.handleClubChange}>
                                        <option value={this.club.id}>{this.club.registeredName ? this.club.registeredName : ''}</option>
                                        {this.props.clubs.map(club => {
                                            return <option key={club.id} value={club.id}>{club.registeredName}</option>
                                        })}

                                    </FormControl >
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="serialNumberText">
                                <Col className='registerFieldLabel' componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12}>{composingLabel('sportOauthLabel.serialNum', 'Serial number', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl
                                        className='registerField'
                                        type="text"
                                        disabled
                                        name='serialNumber'
                                        value={this.state.serialNumberValue} />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </fieldset>

                <fieldset className='registrationFieldSet'>
                    <legend className="registerFieldsetLabel">{composingLabel('sportOauthLabel.clubAdministrativeAddress', 'Club administative address')}</legend>

                    <Row className="show-grid" >
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="adminStreetNameText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel' >{composingLabel('sportOauthLabel.streetName', 'Street name', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='adminStreetName'
                                        maxlength={VARCHAR_255}
                                        defaultValue={this.adminStreetName}
                                        onChange={this.handleChange} />
                                </Col>

                            </FormGroup>
                        </Col>
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="adminHouseNumberText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.houseNum', 'House number', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='adminHouseNumber'
                                        maxlength={VARCHAR_50}
                                        defaultValue={this.adminHouseNumber}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="adminPostalCodeText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.postalCode', 'Postal code', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='adminPostalCode'
                                        maxlength={VARCHAR_50}
                                        defaultValue={this.adminPostalCode}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>

                            <FormGroup className='registerFormGroup' controlId="adminCityNameText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.cityName', 'City name', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='adminCityName'
                                        maxlength={VARCHAR_100}
                                        defaultValue={this.adminCityName}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="adminCountryText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.country', 'Country', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' componentClass="select"
                                        name='adminCountry'
                                        defaultValue={this.adminCountry.id}
                                        onChange={this.handleChange}>
                                        <option value={this.adminCountry.id}>{this.adminCountry.description ? this.adminCountry.description : ''}</option>
                                        {this.props.countries.map(country => {
                                            return <option key={country.id} value={country.id}>{country.description}</option>
                                        })}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>

                            <FormGroup className='registerFormGroup' controlId="adminIsMainStadiumText">
                                <Col componentClass={ControlLabel} lg={12} md={12} sm={12} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.isMainStadiumAddressDiff', 'Is the Main Staium Address different from Administrative address?')}</Col>
                                <Col lg={12} md={12} sm={12} xs={12} className='adminIsMainStadiumRadioField' >
                                    <Col lg={6} md={6} sm={6} xs={6} >

                                        <Radio
                                            type="radio"
                                            value={true}
                                            name="adminIsMainStadium"
                                            id="adminIsMainStadiumRadios1"
                                            onClick={(e) => this.handleRadioChange(e, 'adminIsMainStadium')}
                                        >{composingLabel('sportOauthLabel.yes', 'Yes')}</Radio>
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={6} >

                                        <Radio
                                            type="radio"
                                            value={false}
                                            defaultChecked
                                            name="adminIsMainStadium"
                                            id="adminIsMainStadiumRadios2"
                                            onClick={(e) => this.handleRadioChange(e, 'adminIsMainStadium')}
                                        >{composingLabel('sportOauthLabel.NO', 'NO')}</Radio>
                                    </Col>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </fieldset>
                <fieldset className='registrationFieldSet adminIsMainStadiumFieldset adminIsMainStadiumFieldsetHidden'>
                    <legend className='registerFieldsetLabel'>{composingLabel('sportOauthLabel.clubMainStadiumAddress', 'CLUB Main Stadium Address')}</legend>
                    <Row className="show-grid" >
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="mainStadiumStreetNameText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.streetName', 'Street name', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='mainStadiumStreetName'
                                        maxlength={VARCHAR_255}
                                        defaultValue={this.mainStadiumStreetName}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="mainStadiumHouseNumberText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.houseNum', 'House number', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='mainStadiumHouseNumber'
                                        maxlength={VARCHAR_50}
                                        defaultValue={this.mainStadiumHouseNumber}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>

                            <FormGroup className='registerFormGroup' controlId="mainStadiumPostalCodeText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.postalCode', 'Postal code')}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='mainStadiumPostalCode'
                                        maxlength={VARCHAR_50}
                                        defaultValue={this.mainStadiumPostalCode}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="mainStadiumCityNameText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.cityName', 'City name', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='mainStadiumCityName'
                                        maxlength={VARCHAR_100}
                                        defaultValue={this.mainStadiumCityName}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="mainStadiumCountryText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.country', 'Country', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' componentClass="select"
                                        name='mainStadiumCountry'
                                        defaultValue={this.mainStadiumCountry.id}
                                        onChange={this.handleChange}>
                                        <option value={this.mainStadiumCountry.id}>{this.mainStadiumCountry.description ? this.mainStadiumCountry.description : ''}</option>
                                        {this.props.countries.map(country => {
                                            return <option key={country.id} value={country.id}>{country.description}</option>
                                        })}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="secondStadiumText">
                                <Col componentClass={ControlLabel} lg={12} md={12} sm={12} xs={12} className='registerFieldLabel' >{composingLabel('sportOauthLabel.isSecondStadiumAddress', 'Is there a Second stadium Address?')}</Col>
                                <Col lg={12} md={12} sm={12} xs={12} className='secondStadiumRadioField' >
                                    <Col lg={6} md={6} sm={6} xs={6} >

                                        <Radio
                                            type="radio"
                                            value={true}
                                            name="secondStadium"
                                            id="secondStadiumRadios1"
                                            onClick={(e) => this.handleRadioChange(e, 'secondStadium')}
                                        >{composingLabel('sportOauthLabel.yes', 'Yes')}</Radio>
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={6} >
                                        <Radio
                                            type="radio"
                                            value={false}
                                            defaultChecked
                                            name="secondStadium"
                                            id="secondStadiumRadios2"
                                            onClick={(e) => this.handleRadioChange(e, 'secondStadium')}
                                        >{composingLabel('sportOauthLabel.NO', 'NO')}</Radio>
                                    </Col>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </fieldset >
                <fieldset className='registrationFieldSet secondStadiumFieldset secondStadiumFieldsetHidden'>
                    <legend className='registerFieldsetLabel'>{composingLabel('clubSecondStadiumAddress', 'CLUB Second Stadium Address')}</legend>
                    <Row className="show-grid" >
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="secondStadiumStreetNameText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.streetName', 'Street name', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='secondStadiumStreetName'
                                        maxlength={VARCHAR_255}
                                        defaultValue={this.secondStadiumStreetName}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="secondStadiumHouseNumberText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.houseNum', 'House number', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='secondStadiumHouseNumber'
                                        maxlength={VARCHAR_50}
                                        defaultValue={this.secondStadiumHouseNumber}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="secondStadiumPostalCodeText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.postalCode', 'Postal code', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='secondStadiumPostalCode'
                                        maxlength={VARCHAR_50}
                                        defaultValue={this.secondStadiumPostalCode}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="secondStadiumCityNameText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.cityName', 'City name', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' type="text"
                                        name='secondStadiumCityName'
                                        maxlength={VARCHAR_100}
                                        defaultValue={this.secondStadiumCityName}
                                        onChange={this.handleChange} />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="secondStadiumCountryText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.country', 'Country', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' componentClass="select"
                                        name='secondStadiumCountry'
                                        defaultValue={this.secondStadiumCountry.id}
                                        onChange={this.handleChange}>
                                        <option value={this.secondStadiumCountry.id}>{this.secondStadiumCountry.description ? this.secondStadiumCountry.description : ''}</option>
                                        {this.props.countries.map(country => {
                                            return <option key={country.id} value={country.id}>{country.description}</option>
                                        })}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </fieldset>
            </Form >
        )
    }
}

export default ClubRegistrationFirstStep;


// WEBPACK FOOTER //
// ./src/main/resources/js/components/RegistrationFormComponents/ClubRegistrationFirstStep.js